import { CalendarRange } from "lucide-react";
import { PRESETS, presetRange, DATE_FIELD_LABEL } from "@/lib/auditDates";

const LABEL = "flex flex-col gap-1 text-xs font-semibold text-slate-600 min-w-0";

export const DateFilterBar = ({ dfield, from, to, preset, onChange }) => {
  function pick(key) {
    if (key === "custom") return onChange({ preset: "custom" });
    const [f, t] = presetRange(key);
    onChange({ preset: key, from: f, to: t });
  }
  return (
    <div className="space-y-3 min-w-0" data-testid="date-filter-bar">
      <div
        className="flex flex-nowrap gap-1.5 overflow-x-auto scroll-smooth pb-1 -mx-1 px-1 [scrollbar-width:thin]"
        data-testid="date-presets-row"
      >
        {PRESETS.map((p) => (
          <button
            key={p.key}
            type="button"
            onClick={() => pick(p.key)}
            className={`shrink-0 whitespace-nowrap px-3 py-1.5 rounded-full text-xs font-semibold border transition-colors ${
              preset === p.key ? "bg-slate-900 text-white border-slate-900" : "bg-white text-slate-700 border-slate-300 hover:border-slate-500"
            }`}
            data-testid={`date-preset-${p.key}`}
          >
            {p.label}
          </button>
        ))}
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-[minmax(0,16rem)_minmax(0,11rem)_minmax(0,11rem)] gap-2">
        <label className={`${LABEL} col-span-2 sm:col-span-1`}>
          <span className="flex items-center gap-1"><CalendarRange size={14} /> Consultar por</span>
          <select
            value={dfield}
            onChange={(e) => onChange({ dfield: e.target.value })}
            className="input-base py-2.5 text-sm w-full min-w-0"
            data-testid="filter-date-field"
          >
            {Object.entries(DATE_FIELD_LABEL).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
          </select>
        </label>
        <label className={LABEL}>
          Desde
          <input type="date" value={from} max={to || undefined}
            onChange={(e) => onChange({ from: e.target.value, preset: "custom" })}
            className="input-base py-2.5 text-sm w-full min-w-0" data-testid="filter-date-from" />
        </label>
        <label className={LABEL}>
          Hasta
          <input type="date" value={to} min={from || undefined}
            onChange={(e) => onChange({ to: e.target.value, preset: "custom" })}
            className="input-base py-2.5 text-sm w-full min-w-0" data-testid="filter-date-to" />
        </label>
      </div>
    </div>
  );
};
